import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  Toggle,
  FormElement,
  Select,
  Chip,
  Panel,
  Text,
  TEXT_VARIANT_BOLD,
  Collapsible,
  Flex,
  FlexItem,
  HelpIcon
} from 'mailup-web-components'

import { messageState } from 'Pages/OverviewMessage/recoil/state/message'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { getEndpointsListCallback } from 'Pages/OverviewMessage/recoil/callbacks/callbacks'
import { endpointsListState } from 'Pages/OverviewMessage/recoil/state/list'
import ReactTooltip from 'react-tooltip'

const AdvancedPersonalization = () => {
  const intl = useIntl()
  const { endpointsList, endpointsAttachedToList } = useRecoilValue(
    endpointsListState
  )
  const [
    { endpointsToggle, id, selectedEndpointsList },
    setEndpoints
  ] = useRecoilState(messageState)
  const getEPListCallback = useRecoilCallback(getEndpointsListCallback, [])
  const handleChange = e => {
    const checkState = e.target.checked
    setEndpoints(prev => ({
      ...prev,
      endpointsToggle: checkState,
      isDirty: true
    }))
  }

  function onClickSetEndpointsToggle(checkState) {
    if (!endpointsAttachedToList || endpointsAttachedToList.length === 0) {
      setEndpoints(prev => ({
        ...prev,
        endpointsToggle: !checkState,
        isDirty: true
      }))
    }
  }

  useEffect(() => {
    ReactTooltip.rebuild()
    if (id && !endpointsList) {
      // questa funzione deve essere chiamata una sola volta
      // per il confronto selectedEndpointsList
      getEPListCallback(id).then(res => {
        const eList = res[0]
        const eAttTOList = res[1]

        // setto l'endpoint di base
        const bEndpoint = eList
          .filter(e => e.IsBasic === true)
          .map(e => e.IdContent)
        if (bEndpoint && bEndpoint.length > 0) {
          setEndpoints(prev => ({
            ...prev,
            baseEndpoint: bEndpoint[0]
          }))
          // remove baseEndpoint from selectedEndpoints, if exist
          const sIndex = selectedEndpointsList.findIndex(
            i => i === bEndpoint[0]
          )
          if (sIndex > -1) {
            const newSI = selectedEndpointsList.map(e => e)
            newSI.splice(sIndex, 1)
            setEndpoints(prev => ({
              ...prev,
              selectedEndpointsList: newSI
            }))
          }
        }

        if (eAttTOList.length > 0) {
          setEndpoints(prev => ({
            ...prev,
            endpointsToggle: true
          }))
        } else if (selectedEndpointsList.length > 0) {
          // selectedEndpointsList quando arriva qui ha il valore inziale
          setEndpoints(prev => ({
            ...prev,
            endpointsToggle: true
          }))
        } else {
          setEndpoints(prev => ({
            ...prev,
            endpointsToggle: false
          }))
        }
      })
    }
  }, [id, endpointsList])

  const props = () => ({
    disabled: false,
    placeholder: intl.formatMessage({ id: 'Load.TagSelector.lblSelectTags' }),
    hint:
      (selectedEndpointsList.length ===
        options.filter(eO => eO.hidden === false).length &&
        intl.formatMessage({ id: 'Load.Common.NoMoreOptions' })) ||
      null,
    onChange: value => {
      setEndpoints(prev => ({
        ...prev,
        selectedEndpointsList: value,
        isDirty: true
      }))
    }
  })

  const makeOption = e => ({
    label: `${e.Label}`,
    value: e.IdContent,
    disabled: false,
    hidden:
      e.IsBasic ||
      !!endpointsAttachedToList.find(eF => eF.IdContent === e.IdContent)
  })
  const options =
    endpointsList !== undefined ? endpointsList.map(makeOption) : []

  const handleSubmit = e => {}

  return (
    <>
      <Panel data-mu-test='overview-message__box-advanced-personalization'>
        <Flex justifyContent='space-between' alignItems='center'>
          <FlexItem>
            <Text
              htmlElement='span'
              variant={TEXT_VARIANT_BOLD}
              onClick={() => onClickSetEndpointsToggle(endpointsToggle)}
            >
              {intl.formatMessage({
                id: 'Load.SavedEmailWizard.Personalization'
              })}
            </Text>
            <HelpIcon
              text={intl.formatMessage({
                id:
                  'Load.SavedEmailWizard.TooltipPersonalizationManageEndpoints'
              })}
            />
          </FlexItem>
          {endpointsAttachedToList && endpointsAttachedToList.length > 0 && (
            <Toggle
              disabled
              tooltip={intl.formatMessage({
                id: 'Load.SavedEmailWizard.TooltipPersonalization'
              })}
              checked={endpointsToggle}
              onChange={handleChange}
              label={intl.formatMessage({
                id: 'Load.SavedEmailWizard.LabelEmbeddedImages'
              })}
            />
          )}
          {(!endpointsAttachedToList ||
            endpointsAttachedToList.length === 0) && (
            <Toggle
              tooltip={intl.formatMessage({
                id:
                  'Load.SavedEmailWizard.TooltipPersonalizationManageEndpoints'
              })}
              disabled={false}
              checked={endpointsToggle}
              onChange={handleChange}
              label={intl.formatMessage({
                id: 'Load.SavedEmailWizard.LabelEmbeddedImages'
              })}
            />
          )}
        </Flex>
        <Collapsible collapsed={!endpointsToggle}>
          {endpointsToggle && (
            <Flex flexDirection='column' rowGap='16px'>
              <FlexItem>
                <FormElement
                  labelFor='tags'
                  label={intl.formatMessage({
                    id: 'Load.SavedEmailWizard.Enpoints'
                  })}
                >
                  <Select
                    options={options}
                    {...props()}
                    multiple
                    value={selectedEndpointsList}
                    onSubmit={handleSubmit}
                    data-mu-test='select-tags'
                  />
                </FormElement>
              </FlexItem>
              <FlexItem>
                <Text variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: 'Load.SavedEmailWizard.EndPointCurrentList'
                  })}
                </Text>
                <Flex
                  flexWrap='wrap'
                  alignItems='center'
                  rowGap='4px'
                  columnGap='4px'
                  margin='8px 0 0 0'
                >
                  {endpointsAttachedToList.map(e => {
                    return (
                      <FlexItem key={'endp' + e.IdContent}>
                        <Chip label={e.Label} />
                      </FlexItem>
                    )
                  })}
                </Flex>
              </FlexItem>
            </Flex>
          )}
        </Collapsible>
      </Panel>
    </>
  )
}

export default AdvancedPersonalization
